import { useEffect, useState } from "react";
import moment from "moment";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import classNames from "classnames";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import { CopyEventUrl } from "modules/event/components";
import { useI18n } from "i18n";
import { getInviteUrl } from "helpers/urlHelper";
import { IEvent } from "modules/event/types";
import { ReactComponent as FacebookIcon } from "./assets/facebook.inline.svg";
import { ReactComponent as XIcon } from "./assets/x.inline.svg";
import { ReactComponent as LinkedinIcon } from "./assets/linkedin.inline.svg";
import { useStyles } from "./ShareEvent.styles";

interface Props {
  eventData: IEvent;
  showText?: boolean;
  copyLinkId?: string;
  border?: boolean;
}

const ShareEvent = ({
  eventData,
  showText,
  copyLinkId,
  border = true,
}: Props) => {
  const styles = useStyles();
  const [inviteLink, setInviteLink] = useState("");
  const { t } = useI18n(["eventLanding"]);

  const fbQuote = `I am joining ${eventData.name} on ${moment(
    eventData.startTime,
  ).format("MM/DD/YYYY")} inside @use_remo! Learn with me here.`;
  const hashtag = "";

  useEffect(() => {
    const updateInviteURL = async () => {
      const inviteUrl = await getInviteUrl(eventData);

      setInviteLink(inviteUrl);
    };

    if (eventData) {
      updateInviteURL();
    }
  }, [eventData]);

  return (
    <section
      className={classNames(
        styles.shareContainer,
        border && styles.shareContainerWithBorder,
      )}
      data-testid="share-event-buttons"
    >
      <Typography variant="h5">{t("eventLanding:share.event")}</Typography>
      <ul className={styles.list}>
        <li className={styles.listItem}>
          <FacebookShareButton
            url={inviteLink}
            quote={`${fbQuote} ${inviteLink}`}
            hashtag={hashtag}
            className={styles.shareButton}
          >
            <FacebookIcon className={styles.svgIcon} alt="Facebook" />
          </FacebookShareButton>
        </li>
        <li className={styles.listItem}>
          <TwitterShareButton
            url={inviteLink}
            title={`${fbQuote}`}
            className={styles.shareButton}
          >
            <XIcon className={styles.svgIcon} alt="X" />
          </TwitterShareButton>
        </li>
        <li className={styles.listItem}>
          <LinkedinShareButton
            url={inviteLink}
            title={`${fbQuote} ${inviteLink}`}
            summary={`${fbQuote} ${inviteLink}`}
            className={styles.shareButton}
          >
            <LinkedinIcon className={styles.svgIcon} alt="LinkedIn" />
          </LinkedinShareButton>
        </li>
      </ul>
      {showText && copyLinkId && (
        <CopyEventUrl event={eventData} copyLinkId={copyLinkId} />
      )}
    </section>
  );
};

export default ShareEvent;
